import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=621b0770&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=ts&"
export * from "./Contact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b0770",
  null
  
)

component.options.__file = "Contact.vue"
export default component.exports